const hotKeys = {
  shift: ['shift'],
  command: ['Ctrl', 'command'],
  option: ['option', 'alt'],
  control: ['ctrl'],
  esc: ['esc'],
};

export default hotKeys;
